const annualResults = {
  "2021-сьогодні":
    "https://drive.google.com/drive/folders/1fM-n9lNRn9PW_5WCPp-Np3WBqy0pgZ2g?hl=ru",
};

export { annualResults };
